import type { MaintenanceWindow, StatusComponent } from '../api/statusApi';
import { formatDateTime } from '../statusMeta';
import { IconWrench } from './icons';
import './MaintenanceList.css';

interface Props {
  windows: MaintenanceWindow[];
  components: StatusComponent[];
}

export function MaintenanceList({ windows, components }: Props) {
  if (windows.length === 0) return null;
  const byId = new Map(components.map((c) => [c.id, c.name]));

  return (
    <section className="maintenance-list card" aria-label="Upcoming maintenance">
      <h2>Upcoming maintenance</h2>
      <ul className="maintenance-list__items">
        {windows.map((w) => (
          <li key={w.id} className="maintenance-item">
            <IconWrench className="maintenance-item__icon" />
            <div>
              <p className="maintenance-item__title">{w.title}</p>
              <p className="maintenance-item__meta">
                {w.component_ids.map((id) => byId.get(id) ?? id).join(', ')} · {formatDateTime(w.starts_at)}
                {' – '}
                {formatDateTime(w.ends_at)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
